import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import env from "../services/env";

const SESSION_KEY = "tillionx:analytics-session";
const LAST_SEEN_KEY = "tillionx:analytics-last-seen";
const LAST_PAGE_KEY = "tillionx:analytics-last-page";
const LAST_PAGE_AT_KEY = "tillionx:analytics-last-page-at";
const SESSION_TIMEOUT = 30 * 60 * 1000;

function createSessionId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (character) => {
    const value = Math.floor(Math.random() * 16);
    return (character === "x" ? value : (value & 0x3) | 0x8).toString(16);
  });
}

function getSessionId(now) {
  try {
    let sessionId = window.sessionStorage.getItem(SESSION_KEY);
    const lastSeen = Number(window.sessionStorage.getItem(LAST_SEEN_KEY) || 0);

    if (!sessionId || now - lastSeen > SESSION_TIMEOUT) {
      sessionId = createSessionId();
      window.sessionStorage.setItem(SESSION_KEY, sessionId);
    }

    window.sessionStorage.setItem(LAST_SEEN_KEY, String(now));
    return sessionId;
  } catch {
    return null;
  }
}

function getReferrerOrigin() {
  try {
    return document.referrer ? new URL(document.referrer).origin : null;
  } catch {
    return null;
  }
}

export default function TrafficTracker() {
  const location = useLocation();

  useEffect(() => {
    if (
      process.env.NODE_ENV === "development" &&
      process.env.REACT_APP_ANALYTICS_ENABLED !== "true"
    ) return;

    const now = Date.now();
    const sessionId = getSessionId(now);
    if (!sessionId) return;

    const path = location.pathname || "/";
    const trackedPage = `${sessionId}:${path}`;
    const previousPage = window.sessionStorage.getItem(LAST_PAGE_KEY);
    const previousPageAt = Number(window.sessionStorage.getItem(LAST_PAGE_AT_KEY) || 0);

    if (trackedPage === previousPage && now - previousPageAt < 1000) return;

    window.sessionStorage.setItem(LAST_PAGE_KEY, trackedPage);
    window.sessionStorage.setItem(LAST_PAGE_AT_KEY, String(now));

    fetch(`${env.url}/analytics/page-view`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        path,
        referrer: getReferrerOrigin(),
      }),
      keepalive: true,
    }).catch(() => undefined);
  }, [location.pathname]);

  return null;
}